import type { CreativeImportRowDto, MarketplaceFulfillmentStatus } from "@nexus/contracts";
import { requiresProductionScheduling } from "@nexus/contracts";

export function resolveImportRowStatus(row: {
  fulfillmentStatus: MarketplaceFulfillmentStatus | null;
  suggestedFulfillment: MarketplaceFulfillmentStatus;
}): MarketplaceFulfillmentStatus {
  return row.fulfillmentStatus ?? row.suggestedFulfillment;
}

export function rowIsInProduction(row: {
  fulfillmentStatus: MarketplaceFulfillmentStatus | null;
  suggestedFulfillment: MarketplaceFulfillmentStatus;
}): boolean {
  return requiresProductionScheduling(resolveImportRowStatus(row));
}
